/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TipoPraticaAttributoEsercenteValoreDTO { 
    id?: string;
    attributo_id?: string;
    label?: string;
    value?: string;
    ordine?: number;
    is_default?: boolean;
    version?: number;
    created_at?: string;
    updated_at?: string;
}

